

const columns = [
  {
    title: "User",
    dataIndex: "user",
  },
  {
    title: "Ticket No",
    dataIndex: "ticketNo",
  },
  {
    title: "Query Type",
    dataIndex: "queryName",
  },
  {
    title: "Title",
    dataIndex: "title",
  },
  {
    title: "Contact Name",
    dataIndex: "name",
  },
  // {
  //   title: "User Type",
  //   dataIndex: "ticketUserType",
  // },

  {
    title: "Priority",
    dataIndex: "priority",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Actions",
    dataIndex: "actions",
  },
];

export default columns;
